'use client';

import { useSyncExternalStore } from 'react';

// Keep the DOM order aligned with the responsive `md` composer layout. The
// welcome suggestions sit before the composer on phones and after it at md+.
const PHONE_COMPOSER_QUERY = '(max-width: 47.999rem)';

const readPhoneLayout = (): boolean =>
  typeof matchMedia === 'function' && matchMedia(PHONE_COMPOSER_QUERY).matches;

const readServerLayout = (): boolean => false;

const subscribeToPhoneLayout = (notify: () => void): (() => void) => {
  if (typeof matchMedia !== 'function') return () => {};
  const query = matchMedia(PHONE_COMPOSER_QUERY);
  query.addEventListener('change', notify);
  return () => query.removeEventListener('change', notify);
};

export function usePhoneComposerLayout(): boolean {
  return useSyncExternalStore(subscribeToPhoneLayout, readPhoneLayout, readServerLayout);
}
